import { MessageSquareCode } from 'lucide-react';
import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
import { codeReviewWeb } from '../web-manifest.js';

export default createWebRegistrationFromManifest(
  codeReviewWeb,
  {
    ReviewTab: () => import('./ReviewTab'),
    ReviewTabPreview: () => import('./ReviewTabPreview'),
    ReviewSubmitChip: () => import('./ReviewSubmitChip'),
  },
  {
    icons: { MessageSquareCode },
  },
);
